import { IBillRequestData, IProviderServiceResponse, ISingleReceiptPayProviderServiceRequest } from 'utils/types';

export const checkIsDataInArray = (
	data: IProviderServiceResponse,
	list: ISingleReceiptPayProviderServiceRequest[]
): boolean => {

	return !!list.find((item) => {
		const isEqualById = item.id === data.id;

		if ((data.tarifItems as IBillRequestData)?.id && item.billId) {
			return isEqualById && item.billId === (data.tarifItems as IBillRequestData)?.id;
		}

		return isEqualById;
	});
};
